<template lang="html">
    <div>
        <template>
            <p>Êtes-vous sûr de vouloir supprimer ce produit ?</p>
			<p><strong>{{params.product.label}}</strong></p>
        </template>

    </div>
</template>

<script>
export default {
    props: {
        params: {
            required: false
        }
    },

	data() {
		return {
			title: 'Supression d\'un produit',
			icon: 'delete',
			warning: true
		}
	},

	methods: {
		onClose() {
			this.$eventHub.$emit('close-modal')
		},

		onValidate() {
			this.axios.delete('/api/products/' +  this.params.product.id)
				.then(response => {
					this.$eventHub.$emit('close-modal');
                    if(response.status === 200) {
                        this.$eventHub.$emit('reload-single');
                    }
				})
				.catch(error => {
					console.log(error.response.data || error)
				})
		}
	}

}
</script>

<style lang="stylus" scoped>
div {
    padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/views/projects/single/DeleteProduct.vue